module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAAC3RSTlMAECAwP0BgkMDg8LbnKEcAAABMSURBVAjXY2DAAEwuYKDAUL0bDLYz7IYChm4IvYNBCsKYyMC8GkTvMmBgsAIxFgP1s4IYBiCTsnfv3gY2km337gSI4dnbYLYoMGADAGPnKP2sxawDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgnew/arrow-d-w.png
// module id = Qs4A
// module chunks = 1